import { NavController, NavParams, App, ModalController, ViewController, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { Component, OnInit, Input } from '@angular/core';

import { AuthProvider } from '../../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../../providers/employeerh/employeerh';
import { RhInterviewDisplayPage } from '../rh-interview-display/rh-interview-display';


@Component({
  selector: 'page-rh-interview-list',
  templateUrl: 'rh-interview-list.html',
})
export class RhInterviewListPage implements OnInit {

  interviews:any = null;
  interviewsCustom:any = null;


  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storageProvider: Storage,
    public app: App,
    public authProvider: AuthProvider,
    public employeeRhProvider: EmployeeRhProvider,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController
  ) {
  }

  ngOnInit() {
        this.loadDatas();
  }

  loadDatas() {
    this.employeeRhProvider.getUserDoneInterviews().subscribe((res) => {
        if(res.success){
            this.interviews = res.data.outputAnnual;
            this.interviewsCustom = res.data.outputCustoms;
        }
    })
  }

  openInterview(id, isCustom){
    let modalView = this.modalCtrl.create(RhInterviewDisplayPage, {id, isCustom}, {
        cssClass: 'my-popover'
      });
      modalView.onDidDismiss(() => {
        this.loadDatas()
      })
      modalView.present().then(() => {});
  }

// Modal ctrl
dismiss() {
    this.viewCtrl.dismiss();
}


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-interview/rh-interview-list/rh-interview-list.ts